import "../../utils/tailwind.css";
import { PageProvider, useBlogsProvider } from "./provider";
import Label from "../../components/label";
import Section from "../../components/section";
import Trash from "../../components/svg/trash";
import Pencil from "../../components/svg/pencil";
import TableLoader from "../../components/table-loader";
import Button from "../../components/Buttons";
import Input from "../../components/input";

export default function AddUser() {
  return (
    <div className="p-3">
      <PageProvider>
        <PageContent />
      </PageProvider>
    </div>
  );
}

function PageContent() {
  const { getPlansQuery, handleEditClick, handleWorkDelete, handleAddNewClick, handlePageChange, currentPage, handleSeqChange } = useBlogsProvider();

  const paging = getPlansQuery?.data?.data?.paging || {};

  if (getPlansQuery?.isPending) {
    return <TableLoader />;
  }

  return (
    <Section>
      <div className="flex flex-end w-full mt-4 justify-between items-center">
        <Label className="mb-0 text-black text-[16px] font-semibold" label="Plans list" />
        <Button className="!text-[12px]" onClick={handleAddNewClick}>
          Add New Plan
        </Button>
      </div>
      <div className="overflow-x-auto mb-10 mt-2">
        <table className="w-full border-collapse border border-gray-300">
          <thead className="bg-gray-200">
            <tr>
              <th className="border font-semibold border-gray-300 px-4 py-2 text-left text-[16px] w-[1%]">Sr.No</th>
              <th className="border font-semibold  border-gray-300 px-4  text-left text-[16px] w-[8%]">Plan</th>
              <th className="border font-semibold  border-gray-300 px-4 text-left text-[16px] w-[14%]">Description</th>
              <th className="border font-semibold  border-gray-300 px-4 text-left text-[16px] w-[4%]">Price</th>
              <th className="border font-semibold  border-gray-300 px-4 text-left text-[16px] !w-[1.5%]">Seq. No.</th>
              <th className="border font-semibold  border-gray-300 px-4 text-left text-[16px] w-[1%]">Action</th>
            </tr>
          </thead>
          <tbody>
            {getPlansQuery?.data?.data?.data?.map((item, index) => (
              <tr key={index} className="!h-10">
                <td className="border border-gray-300 px-2">
                  <Label className="mb-0 text-black text-center text-[16px]" label={index + 1} />
                </td>
                <td className="border border-gray-300 px-4">
                  <Label className="mb-0 text-black text-[16px]" label={item.plan_title} />
                </td>
                <td className="border border-gray-300 px-4">
                  <Label className="mb-0 text-black text-[16px]" label={item.plan_description} />
                </td>
                <td className="border border-gray-300 px-4">
                  <Label className="mb-0 text-black text-[16px]" label={item.plan_price} />
                </td>
                <td className="border border-gray-300 px-4">
                  <Input defaultValue={item.seq_no} className="!w-[100%] !h-[20px]" rootClassName="w-[100%]" onChange={handleSeqChange(item)} />
                </td>
                <td className="flex items-center justify-center border border-gray-300 text-center py-[10px]">
                  <Pencil className="ml-2 cursor-pointer" onClick={() => handleEditClick(item)} />
                  <Trash className="mr-4 ml-5 cursor-pointer" onClick={() => handleWorkDelete(item)} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="flex justify-end mt-4 pr-4">
          <div className="flex gap-2">
            {Array.from({ length: paging.total_pages || 1 }, (_, i) => i + 1).map((pageNo) => (
              <button
                key={pageNo}
                onClick={() => handlePageChange(pageNo)}
                className={`px-3 py-1 border rounded ${currentPage === pageNo ? "bg-black text-white" : "bg-white text-black"}`}
              >
                {pageNo}
              </button>
            ))}
          </div>
        </div>
      </div>
    </Section>
  );
}
